import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  type IconStyleOverrides,
  type AngelouCSS,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  breakpoints: { BreakpointNames },
  colors: { ui },
} = constants;
const { fontFamily, fontSize, textMObj } = typographyStyles;

export const rootCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "8px 32px",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    marginLeft: "-30px",
    width: "calc(100% + 29px)",
  },
};

export const rootCssWithBorder: CSSObject = {
  ...rootCss,
  borderBottom: `1px solid ${ui.neutral[50]}`,
};

export const iconCss = (
  isCreateStandardMode: boolean,
): IconStyleOverrides<AngelouCSS> => ({
  root: {
    position: "relative",
    left: "42px",
    height: "20px",
    color: ui.neutral[700],

    circle: {
      stroke: ui.neutral[500],
      strokeWidth: "2.5px",
    },
    path: {
      stroke: ui.neutral[500],
      strokeWidth: "2.5px",
    },
    ...(!isCreateStandardMode && {
      top: "8px",
    }),
    ...(isCreateStandardMode && {
      [mediaQuery.upTo(BreakpointNames.sm)]: {
        left: "40px",
      },
    }),
  },
});

export const createStandardInputcss: CSSObject = {
  display: "flex",
  height: "42px",
  width: "252px",
  paddingLeft: "44px",
  color: ui.neutral[700],
  ...textMObj,

  border: `1px solid ${ui.neutral[200]}`,
  borderRadius: "0.5rem",

  "::placeholder": {
    ...textMObj,
    color: ui.neutral[500],
  },
  marginTop: "4px",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    width: "100%",
  },
};

export const labelTextCss = {
  ...fontFamily.circular,
  ...fontSize.textXS,
  color: ui.neutral[700],
  fontWeight: "bold",
};

export const labelCss = (isCreateStandardMode: boolean) => ({
  display: "block",
  marginTop: isCreateStandardMode ? "-27px" : "-8px",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    width: "100%",
  },
});
